import { ENTITY_LABELS } from "../../../utils/labelMapping";
import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Grid,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { DeleteOutlineRounded } from "@mui/icons-material";
import { dynamicReplace } from "../../Dashboard/Component/ActionComponent/ActionModal";

const FocusAreas = ({ data, setData, type, isAudit=false, isPropensityToBuy=false, mapMetricTitle }) => {
  // const [data, setData] = useState(input);
  const visibilityKey = isAudit ? "visibility": "reach";
  const negativeDriverKey = isAudit ? "negativeSentimentDrivers": "sentimentDrivers"
  const [modalOpen, setModalOpen] = useState(false);
  const [newSection, setNewSection] = useState(visibilityKey);
  const [newItemText, setNewItemText] = useState("");

  // Use mapMetricTitle if available, otherwise use default titles
  const getTitle = (title) => {
    if (mapMetricTitle && typeof mapMetricTitle === 'function') {
      return mapMetricTitle(title);
    }
    return title;
  };

  const titleMapping = {
    // reach: "Visibility",
    ...(visibilityKey && {
    [visibilityKey]: 'Rank',
  }),
    positiveSentimentDrivers: getTitle("Positive Sentiment Drivers"),
    ...(negativeDriverKey && {
    [negativeDriverKey]: getTitle("Negative Sentiment Drivers"),
  }),
    // sentimentDrivers: "Negative Sentiment Drivers",
    positiveAttributes: "Positive Attributes",
    negativeAttributes: "Negative Attributes",
    purchaseCriteria: ENTITY_LABELS.PurchaseCriteria
  };

  if (type === "Product") {
    titleMapping.productDimensions = "Product Dimensions";
  } else {
    titleMapping.brandPillars = `${ENTITY_LABELS.Brand} Pillars`;
  }

  const handleCheckboxChange = (section, index) => {
    const updated = [...data[section]];
    updated[index].selected = !updated[index].selected;
    setData({ ...data, [section]: updated });
  };

  const handleDelete = (section, index) => {
    const updated = [...data[section]];
    updated[index].selected = !updated[index].selected;
    const newSectionData = updated.filter((item, idx) => idx !== index);
    setData({ ...data, [section]: newSectionData });
  };

  const handleAddItem = () => {
    if (newItemText.trim()) {
      setData((prev) => ({
        ...prev,
        [newSection]: [
          ...prev[newSection],
          { text: newItemText, selected: false },
        ],
      }));
      setNewItemText("");
      setModalOpen(false);
    }
  };

  // if (!data) return;

  return (
    <Box
      sx={{
        p: 3,
        backgroundColor: "#ffffff",
        borderRadius: "8px",
        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* Header with Buttons */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333" }}>
          Optimization Focus Area Identification
        </Typography>
        <Box>
          <Button
            onClick={() => setModalOpen(true)}
            sx={{
              backgroundColor: "#4FD1C5",
              color: "#fff",
              fontWeight: "bold",
              textTransform: "none",
              px: 2,
              py: 1,
              borderRadius: "8px",
              mr: 2,
            }}
          >
            + Add Item Manually
          </Button>
        </Box>
      </Box>

      {/* Section Display */}

      <Grid container spacing={2}>
        {Object.entries(titleMapping).map(
          ([sectionKey, sectionLabel], sectionIdx) =>
            // For "Reach", use full width
            sectionKey === visibilityKey ? (
              <Grid item xs={12} key={sectionKey}>
                <Box sx={{ mb: 2 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, mb: 1 }}
                  >
                    {sectionLabel}
                  </Typography>
                  <Grid container spacing={1}>
                    {data?.[sectionKey] && data?.[sectionKey].length > 0 ? (
                      data?.[sectionKey]?.map((item, idx) => (
                        <Grid item xs={6} md={6} key={idx}>
                          <Box
                            sx={{
                              backgroundColor: item?.isActionable
                                ? "pink"
                                : "#EFF4F8",
                              borderRadius: "6px",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              px: 2,
                              py: 1,
                            }}
                          >
                            <Typography
                              sx={{ fontSize: "14px", color: "#333" }}
                            >
                              {dynamicReplace(item?.text)}
                            </Typography>
                            <div>
                              <Button
                                onClick={() => {
                                  handleDelete(sectionKey, idx);
                                }}
                              >
                                <DeleteOutlineIcon />
                              </Button>

                              <Checkbox
                                checked={item?.selected}
                                onChange={() =>
                                  handleCheckboxChange(sectionKey, idx)
                                }
                              />
                            </div>
                          </Box>
                        </Grid>
                      ))
                    ) : (
                      <Grid item xs={6} md={6}>
                        <Box
                          sx={{
                            backgroundColor: "#EFF4F8",
                            borderRadius: "6px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            px: 2,
                            py: 1,
                          }}
                        >
                          <Typography sx={{ fontSize: "14px", color: "#333" }}>
                            Nothing here !
                          </Typography>
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </Grid>
            ) : (
              // For other sections (Positive/Negative Drivers) → 2-column sections
              <Grid item xs={12} md={6} key={sectionKey}>
                <Box sx={{ mb: 2 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, mb: 1 }}
                  >
                    {sectionLabel}
                  </Typography>
                  <Grid container spacing={1}>
                    {data?.[sectionKey] && data?.[sectionKey].length > 0 ? (
                      data?.[sectionKey]?.map((item, idx) => (
                        <Grid item xs={12} key={idx}>
                          <Box
                            sx={{
                              backgroundColor: item?.isActionable
                                ? "pink"
                                : "#EFF4F8",
                              borderRadius: "6px",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              px: 2,
                              py: 1,
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "14px",
                                color: "#333",
                                width: "250px",
                              }}
                            >
                              {getTitle(item?.text)}
                            </Typography>
                            {(sectionLabel === `${ENTITY_LABELS.Brand} Pillars` ||
                              sectionLabel === ENTITY_LABELS.PurchaseCriteria ||
                              sectionLabel === "Product Dimensions") && (
                              <Typography
                                sx={{ fontSize: "14px", color: "#333" }}
                              >
                               Rating: {Number(item.score).toFixed(0)}
                              </Typography>
                            )}
                            <div>
                              <Button
                                onClick={() => {
                                  handleDelete(sectionKey, idx);
                                }}
                              >
                                <DeleteOutlineRounded />
                              </Button>

                              <Checkbox
                                checked={item?.selected}
                                onChange={() =>
                                  handleCheckboxChange(sectionKey, idx)
                                }
                              />
                            </div>
                          </Box>
                        </Grid>
                      ))
                    ) : (
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            backgroundColor: "#EFF4F8",
                            borderRadius: "6px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            px: 2,
                            py: 1,
                          }}
                        >
                          <Typography sx={{ fontSize: "14px", color: "#333" }}>
                            Nothing here !
                          </Typography>
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </Grid>
            )
        )}
      </Grid>

      {/* Modal for Adding Item */}
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>Add New Item</DialogTitle>
        <DialogContent sx={{ minWidth: 300 }}>
          <Select
            fullWidth
            value={newSection}
            onChange={(e) => setNewSection(e.target.value)}
            sx={{ mb: 2 }}
          >
            {Object.entries(titleMapping).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                {label}
              </MenuItem>
            ))}
          </Select>
          <TextField
            fullWidth
            label="Enter item text"
            value={newItemText}
            onChange={(e) => setNewItemText(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalOpen(false)}>Cancel</Button>
          <Button
            onClick={handleAddItem}
            variant="contained"
            sx={{ backgroundColor: "#4FD1C5" }}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default FocusAreas;